import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = axios.create({ baseURL: `${BACKEND_URL}/api` });

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('amazonia_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('amazonia_token');
      localStorage.removeItem('amazonia_user');
    }
    return Promise.reject(error);
  }
);

// Public
export const getCategories = () => API.get('/categories');
export const getProducts = (params) => API.get('/products', { params });
export const getProduct = (id) => API.get(`/products/${id}`);
export const submitContact = (data) => API.post('/contact', data);
export const getPublicSettings = () => API.get('/settings/public');

// Auth
export const registerUser = (data) => API.post('/auth/register', data);
export const loginUser = (data) => API.post('/auth/login', data);
export const getMe = () => API.get('/auth/me');

// Cart
export const getCart = () => API.get('/cart');
export const addToCart = (data) => API.post('/cart/add', data);
export const updateCart = (data) => API.put('/cart/update', data);
export const removeFromCart = (id) => API.delete(`/cart/remove/${id}`);
export const clearCart = () => API.delete('/cart/clear');

// Orders
export const createOrder = (data) => API.post('/orders', data);
export const getOrders = () => API.get('/orders');
export const getOrder = (id) => API.get(`/orders/${id}`);

// Dashboard
export const getReorderData = () => API.get('/dashboard/reorder');

// Admin
export const getAdminDashboard = () => API.get('/admin/dashboard');
export const getAdminSettings = () => API.get('/admin/settings');
export const updateAdminSettings = (data) => API.put('/admin/settings', data);
export const getAdminProducts = (params) => API.get('/admin/products', { params });
export const getAllProductIds = (params) => API.get('/admin/products/all-ids', { params });
export const updateAdminProduct = (id, data) => API.put(`/admin/products/${id}`, data);
export const deactivateProduct = (id) => API.delete(`/admin/products/${id}`);
export const bulkProductAction = (data) => API.post('/admin/products/bulk-action', data);
export const importCsv = (formData) => API.post('/admin/csv-import', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const importXlsx = (formData) => API.post('/admin/xlsx-import', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const getImportHistory = () => API.get('/admin/import-history');
export const getAdminSuppliers = () => API.get('/admin/suppliers');
export const createSupplier = (data) => API.post('/admin/suppliers', data);
export const updateSupplier = (id, data) => API.put(`/admin/suppliers/${id}`, data);
export const deleteSupplier = (id) => API.delete(`/admin/suppliers/${id}`);
export const getAdminClients = (params) => API.get('/admin/clients', { params });
export const updateClient = (id, data) => API.put(`/admin/clients/${id}`, data);
export const getAdminOrders = (params) => API.get('/admin/orders', { params });
export const updateOrderStatus = (id, data) => API.put(`/admin/orders/${id}/status`, data);

export default API;
